export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === from.path) return

  const store = useLanguageSwitcherStore()

  // Check if this is a language switch navigation
  const isDrupalLanguageSwitch = store.drupal.links.some((link) => link.path === to.path)
  const isShopwareLanguageSwitch = Boolean(store.shopware.entityId && to.path.includes('/'))

  // Extract base paths without locale prefixes for comparison
  const toPathNoLocale = to.path.replace(/^\/[a-z]{2}(?:-[A-Z]{2})?(?=\/|$)/, '') || '/'
  const fromPathNoLocale = from?.path?.replace(/^\/[a-z]{2}(?:-[A-Z]{2})?(?=\/|$)/, '') || '/'

  // Clear store only when navigating to a completely different page
  // (not just a language variant of the same page)
  const isDifferentPage = toPathNoLocale !== fromPathNoLocale
  const isLanguageSwitch = isDrupalLanguageSwitch || isShopwareLanguageSwitch

  if (isDifferentPage && !isLanguageSwitch) {
    store.clear()
  }
})
